<template>
  <section class="bg-background-light py-20 lg:py-28" :id="id">
    <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
      <div class="mx-auto mb-14 max-w-[640px] text-center">
        <h2 class="text-4xl font-black leading-[1.05] tracking-[-0.02em] text-text-main sm:text-5xl">{{ t('services.title') }}</h2>
      </div>

      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        <ServiceCard icon="smart_toy" :title="t('services.s1_title')" :text="t('services.s1_text')" featured />
        <ServiceCard icon="web" :title="t('services.s2_title')" :text="t('services.s2_text')" />
        <ServiceCard icon="smartphone" :title="t('services.s3_title')" :text="t('services.s3_text')" />
        <ServiceCard icon="brush" :title="t('services.s4_title')" :text="t('services.s4_text')" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ServiceCard from './partials/ServiceCard.vue';

defineProps<{ id?: string }>();

const { t } = useI18n();
</script>
